import React from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../../Layout";
import { motion } from "framer-motion";

import PageBreadcrumb from "components/shared-components/PageBreadcrumb";
import ProductsTab from "./tabs/ProductsTab";
import OrderDetailsTab from "./tabs/OrderDetailsTab";
import InvoiceTab from "./tabs/InvoiceTab";

const Order = () => {
  const { orderId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [tabValue, setTabValue] = useState("details");

  const order = {
    reference: "70d4d7d0",
    customer: {
      firstName: "Dolite",
      lastName: "Bullock",
    },
  };

  // --- Loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full py-20">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // --- Error state
  if (isError || !order) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        className="flex flex-col items-center justify-center h-full py-20"
      >
        <p className="text-gray-500 text-lg font-medium">
          There is no such order!
        </p>
        <Link
          to="/apps/e-commerce/orders"
          className="mt-6 inline-flex items-center px-4 py-2 text-sm font-semibold border border-gray-400 text-gray-700 rounded-md hover:bg-gray-100 transition"
        >
          Go to Orders Page
        </Link>
      </motion.div>
    );
  }

  return (
    <Layout>
      <div className="p-3 lg:p-6 space-y-8">
        {/* Breadcrumb */}

        <motion.div
          initial={{ x: 20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.2 } }}
        >
          <PageBreadcrumb className="mb-4" />
        </motion.div>

        <motion.div
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.2 } }}
          className="flex flex-col"
        >
          <h1 className="text-2xl font-semibold text-text">
            Order {order.reference}
          </h1>
          <p className="text-textGray text-sm mt-1">
            From {order.customer.firstName} {order.customer.lastName}
          </p>
        </motion.div>

        {/* Tabs */}
        <div className="flex border-b border-border mb-6 text-sm font-medium">
          <button
            onClick={() => setTabValue("details")}
            className={`px-4 py-2 ${
              tabValue === "details"
                ? "border-b-2 bg-redlight rounded-t-xl border-redlight text-white"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Order Details
          </button>
          <button
            onClick={() => setTabValue("products")}
            className={`px-4 py-2 ${
              tabValue === "products"
                ? "border-b-2 bg-redlight rounded-t-xl border-redlight text-white"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Products
          </button>
          <button
            onClick={() => setTabValue("invoice")}
            className={`px-4 py-2 ${
              tabValue === "invoice"
                ? "border-b-2 bg-redlight rounded-t-xl border-redlight text-white"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Invoice
          </button>
        </div>
        {tabValue === "details" && <OrderDetailsTab />}
        {tabValue === "products" && <ProductsTab />}
        {tabValue === "invoice" && <InvoiceTab order={order} />}
      </div>
    </Layout>
  );
};

export default Order;
